import { MAZE_CELL_SIZE } from '@/constants/maze';
import { getDirectionVector } from '@/lib/maze/maze-gen';
import type { MazeStagePixiPalette } from '@/theme/maze-stage-palette';
import { Direction, type MazeCell } from '@/types/maze';
import { gsap } from 'gsap';
import * as PIXI from 'pixi.js';

function drawDoubleChevron(arrow: PIXI.Graphics, direction: Direction, color: number): void {
  const size = 4.4;
  const offsets = [2.8, -3.2];
  arrow.lineStyle(2, color, 0.86);

  for (const offset of offsets) {
    if (direction === Direction.RIGHT) {
      arrow.moveTo(offset - size, -size);
      arrow.lineTo(offset, 0);
      arrow.lineTo(offset - size, size);
      continue;
    }
    if (direction === Direction.LEFT) {
      arrow.moveTo(offset + size, -size);
      arrow.lineTo(offset, 0);
      arrow.lineTo(offset + size, size);
      continue;
    }
    if (direction === Direction.UP) {
      arrow.moveTo(-size, offset + size);
      arrow.lineTo(0, offset);
      arrow.lineTo(size, offset + size);
      continue;
    }
    arrow.moveTo(-size, offset - size);
    arrow.lineTo(0, offset);
    arrow.lineTo(size, offset - size);
  }

  arrow.lineStyle(0);
}

export function clearJunctionArrows(layer: PIXI.Container): void {
  for (const child of layer.children) {
    gsap.killTweensOf(child);
  }
  layer.removeChildren();
}

export function drawJunctionArrows(
  junctionLayer: PIXI.Container,
  row: MazeCell[],
  x: number,
  y: number,
  palette: MazeStagePixiPalette,
): void {
  const currentCell = row[x];
  if (!currentCell) {
    return;
  }

  clearJunctionArrows(junctionLayer);

  for (const direction of [Direction.UP, Direction.DOWN, Direction.LEFT, Direction.RIGHT]) {
    if (!(currentCell.walls & direction)) {
      continue;
    }

    const { dx, dy } = getDirectionVector(direction);
    const arrow = new PIXI.Graphics();
    const arrowX = (x + dx) * MAZE_CELL_SIZE + MAZE_CELL_SIZE / 2;
    const arrowY = (y + dy) * MAZE_CELL_SIZE + MAZE_CELL_SIZE / 2;
    drawDoubleChevron(arrow, direction, palette.playerBase);

    arrow.x = arrowX;
    arrow.y = arrowY;
    junctionLayer.addChild(arrow);

    gsap.to(arrow, {
      alpha: 0.2,
      duration: 0.5,
      repeat: -1,
      yoyo: true,
      ease: 'power1.inOut',
    });
  }
}
